/** Reserve Dining → User Permissions (Activity only — no Retail tab) */

export const diningBookingActionsArea = "Booking Actions" as const;
export const diningGuestCommunicationArea = "Guest Communication" as const;
export const diningManageLocationsArea = "Manage Locations" as const;
export const diningReportsArea = "Reports" as const;
export const diningSettingsAccessArea = "Settings Access" as const;

export const diningBookingActionsPermissionList = [
  "Add Reservations",
  "Manage Reservation with NeverAssign",
  "Add Slots",
  "Add to Standby List",
  "Book in Non Web Reservable or Disabled Slots",
  "Book Or Seat At Blocked Tables",
  "Change Restaurant Settings",
  "Edit Reservations",
  "Edit Slots",
  "Edit Standby Parties",
  "Guest Details Display Settings",
  "Manage Table Blocking Rules",
  "Overbook",
  "Override Do Not Move Reservation Table",
  "Remove Slots",
  "Undo-Cancel",
] as const;

export const diningGuestCommunicationPermissionList = [
  "Book in Slots with Inappropriate Size",
  "Page Parties",
  "View Feedback",
] as const;

export const diningManageLocationsPermissionList = [
  "Book or seat guests at tables associated only to a special meal/event",
  "Cancel Reservation",
  "Move Seated Parties",
  "No-Show reservations",
  "Remove Standby Parties",
  "Send Free form Page Messages",
] as const;

export const diningReportsPermissionList = [
  "Generate Reports",
  "Schedule Reports",
] as const;

export const diningSettingsAccessPermissionList = [
  "Advanced Settings",
  "AppSettings",
  "AuthorizeFormCode",
  "Blocks",
  "Cancellation Policy",
  "Covers",
  "Custom Guest Fields",
  "DiscountPromoCode",
  "EmailTemplateDefinition",
  "GuestCharges",
  "Permissions",
  "Roles",
  "Shift Statistics",
  "SpecialMeals",
  "Users",
] as const;

export type ReserveDiningUserPermissionAreaKey =
  | typeof diningBookingActionsArea
  | typeof diningGuestCommunicationArea
  | typeof diningManageLocationsArea
  | typeof diningReportsArea
  | typeof diningSettingsAccessArea;
